import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { getLangFromPath } from '../lib/blogPaths';
import { setPreferredLangCookie } from '../lib/languagePreference';
import { useLanguage } from './LanguageContext';

/**
 * Syncs LanguageContext and preference cookie with the current URL path.
 * Finnish is the default: root "/" shows Finnish; English home is at "/en". No redirects.
 */
export function SyncLanguageFromPath({ children }) {
  const router = useRouter();
  const [, setLang] = useLanguage();
  const asPath = router?.asPath ?? '';

  useEffect(() => {
    const lang = getLangFromPath(asPath);
    setLang(lang);
    setPreferredLangCookie(lang);
    if (typeof document !== 'undefined' && document.documentElement) {
      document.documentElement.lang = lang;
    }
  }, [asPath, setLang]);

  return children;
}
